import { Trans } from '@lingui/react/macro'

import { H2 } from '../../_components/H2'

import LazyImage from '@/components/LazyImage'


import { cls } from 'tagged-classnames-free';
export const WhyChoose: React.FC = () => {
  return (
    <div className='mx-auto max-w-[1112px] px-4 py-14 md:pb-[168px] md:pt-[160px]'>
      <H2 className='text-center'>
        <Trans>Why Choose Tad AI?</Trans>
      </H2>
      <div className='flex flex-col gap-14 pt-8 md:gap-[120px] md:pt-16'>
        {[
          {
            title: <Trans>Reinvent Music Generation</Trans>,
            desc: (
              <Trans>
                What makes our AI music generator unique is it can intuitively
                grasp any user’s requirements to generate music that aligns
                perfectly with their vision. For us, this also meant taking that
                extra step to integrate a broad range of musical genres and
                styles that cater to any artistic need, be it beginner or
                expert.
              </Trans>
            ),
            img: '/images/about-us/music-generation.jpg',
          },
          {
            title: <Trans>Access 100% Original Music</Trans>,
            desc: (
              <Trans>
                Here at Tad.AI, we are dedicated to providing our users with a
                safe way to create commercially viable music. To ensure this is
                respected, our AI music generator ensures any songs it creates
                under paid plans are entirely original. This guarantees
                copyright-free music that isn’t duplicated or borrowed from
                anywhere else to protect your interests.
              </Trans>
            ),
            img: '/images/about-us/royalty-free.jpg',
            isLeft: true,
          },
          {
            title: <Trans>Enjoy Free AI Music Access</Trans>,
            desc: (
              <Trans>
                When building our AI music generator, we wanted to ensure you
                could produce anything from classical to pop music as many times
                as it takes for you to nail the perfect track at no charge. Our
                team has also worked to ensure you can generate music on any
                device, be it mobile or desktop. So, you can freely create
                unique tracks at anytime in just a few clicks.
              </Trans>
            ),
            img: '/images/about-us/enjoy-free.jpg',
          },
        ].map((item, index) => {
          return (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className={cls`flex ${item.isLeft ? 'md:flex-row' : 'md:flex-row-reverse'} flex-col-reverse items-center gap-8 md:gap-[120px]`}
            >
              <LazyImage
                width={480}
                height={320}
                src={item.img}
                alt=''
                className='rounded-lg'
              />
              <div className='flex-1'>
                <h3 className='text-base font-semibold md:text-4xl'>
                  {item.title}
                </h3>
                <p className='text-f-other-10 pt-2 text-sm md:pt-3 md:text-base'>
                  {item.desc}
                </p>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
